export default "__VITE_ASSET__BOeopEde__"